import React from 'react';
import { BsArchiveFill, BsGearFill } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { Box, Flex, Icon, IconButton } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import IconButtonMenu from '../../../../../../../../../../components/IconButtonMenu';
import { analyticsIds } from '../../../../../../../../../../constants/analyticsIds';
import { CypressIds } from '../../../../../../../../../../constants/cypressIds';
import { InsuredProfilePageDuskIds } from '../../../../../../../../../../constants/duskIds';
import { showModal } from '../../../../../../../../../../redux/modules/modal';
import { useActiveRecordPolicies } from '../../../../../../../../../../services/record-service';
import ArchivedPoliciesModal from '../ArchivedPoliciesModal';

import { menuOptions } from './util';

const PolicyTableIconTray = ({ companyId, recordId, insuredId, jobId }) => {
  const dispatch = useDispatch();
  const { isLoading: policiesLoading } = useActiveRecordPolicies(recordId);

  const showArchivedPolicies = () => {
    dispatch(showModal(() => <ArchivedPoliciesModal insuredId={insuredId} jobId={jobId} recordId={recordId} />, {
      maxWidth: 1040,
      title: 'Archived Policies'
    }));
  };

  return (
    <Box fontSize={18} m={0} zIndex="9999">
      <Flex marginInlineStart={0}>
        <IconButton
          colorScheme="white"
          data-analytics-id={analyticsIds.insuredProfilePage.policiesComponent.openArchivePolicyModalButton}
          data-cy={CypressIds.archivedPoliciesModalButton}
          icon={<Icon as={BsArchiveFill} boxSize="20px" />}
          variant="textWhite"
          onClick={showArchivedPolicies}
        />
        <IconButtonMenu
          ariaLabel="Policy Requirements Menu"
          cypressId={policiesLoading ? CypressIds.loadingPolicyGearIcon : CypressIds.loadedPolicyGearIcon}
          dusk={policiesLoading
            ? InsuredProfilePageDuskIds.loadingPolicyGearIconButton
            : InsuredProfilePageDuskIds.loadedPolicyGearIconButton}
          iconElement={<Icon as={BsGearFill} boxSize="20px" />}
          id={recordId}
          isLoading={policiesLoading}
          menuListWidth="260px"
          menuOptions={menuOptions}
          metadata={{
            recordId,
            insuredId,
            jobId,
            companyId
          }}
          variant="textWhite"
        />
      </Flex>
    </Box>
  );
};

PolicyTableIconTray.propTypes = {
  companyId: PropTypes.string.isRequired,
  recordId: PropTypes.string.isRequired,
  insuredId: PropTypes.string.isRequired,
  jobId: PropTypes.string.isRequired
};

export default PolicyTableIconTray;
